import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { VirtualDimensionForm } from "@costory/front/pages/VirtualDimensions/components/VirtualDimensionForm"
import {
  useCreateDraftVirtualDimensionMutation,
  useCreateVirtualDimensionMutation,
  useVirtualDimensionFormDataQuery,
} from "@costory/front/queries/virtualDimensions"

export const NewVirtualDimensionPage = () => {
  const { mutateAsync: createVirtualDimension, isPending } =
    useCreateVirtualDimensionMutation()
  const {
    mutateAsync: createDraftVirtualDimension,
    isPending: isPendingDraftVirtualDimensions,
  } = useCreateDraftVirtualDimensionMutation()
  const formDataQuery = useVirtualDimensionFormDataQuery()

  return (
    <QueryWrapper query={formDataQuery}>
      {({ data }) => (
        <VirtualDimensionForm
          organizationUsers={data.organizationUsers}
          onSave={createVirtualDimension}
          isSaving={isPending}
          isSavingDraft={isPendingDraftVirtualDimensions}
          onSaveDraft={createDraftVirtualDimension}
        />
      )}
    </QueryWrapper>
  )
}
